import AmountItem from "./AmountItem";
import { currencyFormatter } from "../../../utils/format";
import { useContext, useMemo } from "react";
import PaymentContext from "../../../store/PaymentContext";;

const InvoiceSell = () => {

    const { sellTotal, sellTransportFee }: any = useContext(PaymentContext)

    return (
        <div className="cart-box rounded">
            <div className="px-4 relative h-full">
                <div className="heading line-bottom text-lg">
                    HÓA ĐƠN MUA (tạm tính)
                </div>
                <div className="flex justify-between flex-col box-right-item">
                    <div className="amount-items">
                        <AmountItem
                            label={"Tiền đơn mua"}
                            value={sellTotal}
                            className={"pt-4"}
                        />
                        <AmountItem
                            label={"Phí vận chuyển"}
                            value={sellTransportFee}
                            className={""}
                        />
                    </div>

                    <div className="footer-amount">
                        <div className="pb-2 term-of-payment">
                            Sau khi đặt hàng thành công, sẽ có nhân viên gọi điện để xác nhận đơn hàng.

                        </div>
                        <div className="total_box bold">
                            <AmountItem
                                label={<h4>Tổng</h4>}
                                value={<span className="total_amount">{currencyFormatter.format(sellTotal + sellTransportFee)}</span>}
                                isCurrency={false}
                            />
                        </div>
                        {/*<AmountItem*/}
                        {/*    label={"Số tiền còn lại cần thanh toán"}*/}
                        {/*    value={'5'}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceSell;
